import Delete from '~/assets/icons/common/Delete.svg?react';
import { Box, Button, SxProps, Typography } from '@mui/material';
import { SystemStyleObject, Theme } from '@mui/system';
import { styles as modalStyles } from '~/components/modals/Modal/styles.ts';
import { styles as localStyles } from './styles.ts';
import { BaseModal } from '~/components/modals/BaseModal/BaseModal.tsx';

interface IDeleteDocumentModalProps {
  closeDeleteModal: () => void;
  confirmDelete: () => void;
  showDeleteModal: boolean;
  title: string;
  hideIcon?: boolean;
  confirmBtnText?: string;
  cancelBtnText?: string;
}

export const DeleteModal = ({
  closeDeleteModal,
  showDeleteModal,
  confirmDelete,
  title,
  hideIcon = false,
  confirmBtnText = 'Видалити',
  cancelBtnText = 'Відмінити',
}: IDeleteDocumentModalProps) => {
  return (
    <BaseModal
      open={showDeleteModal}
      onClose={closeDeleteModal}
      containerProps={{
        sx: [modalStyles.modalContainer, localStyles.container] as SxProps,
      }}
    >
      <Box>
        <Box sx={[localStyles.text as SystemStyleObject<Theme>, { height: 40 }]}>
          {!hideIcon && <Delete width="60px" height="40px" display="flex" />}
          <Typography variant={'body1'} sx={{ textAlign: 'center' }}>
            {title}
          </Typography>
        </Box>
        <Box sx={localStyles.button}>
          <Button
            onClick={confirmDelete}
            variant={'contained'}
            data-testid={'confirm-delete-button'}
          >
            {confirmBtnText}
          </Button>
          <Button
            onClick={closeDeleteModal}
            variant={'contained'}
            data-testid={'cancel-delete-button'}
          >
            {cancelBtnText}
          </Button>
        </Box>
      </Box>
    </BaseModal>
  );
};
